import { useForm } from '@mantine/form';

import { goodsTypes } from '../types';

export type Fields = Pick<goodsTypes.Item, 'name' | 'department' | 'key'>;
type GoodsItemFormProps = {
  initialValues: Fields;
};

export const useGoodsItemForm = ({ initialValues }: GoodsItemFormProps) => {
  return useForm({
    initialValues: {
      name: initialValues.name,
      key: initialValues.key,
      department: initialValues.department,
    },

    validate: {
      name: (value) => (!value ? 'Name is required' : null),
      key: (value) => (!value ? 'Key is required' : null),
      department: (value) => (!value ? 'Department is required' : null),
    },
  });
};
